import './ScrollUp.scss'

import { ArrowUpOutlined } from '@ant-design/icons'
import { Button } from 'antd'
import { useEffect, useState } from 'react'

const ScrollUp = () => {
  const [isVisible, setIsVisible] = useState(false)
  
  const handleScroll = () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop
    setIsVisible(scrollTop > 300)
  }

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }

  useEffect(() => {
    window.scroll(0, 0)
    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  return (
    <>
      {isVisible && (
        <Button type="primary" onClick={scrollToTop} className="scroll-to-up-container">
          <ArrowUpOutlined /> Yukarı Çık
        </Button>
      )}
    </>
  )
}

export default ScrollUp
